import styled from '@emotion/styled'
import { colors, fonts, fontSizes } from 'src/utils/styles'
import { IS_BLACK_FRIDAY } from 'src/utils/globals'

export const StFilterAmount = styled.span`
  border-radius: 50%;
  background-color: ${colors.lemonadeYellow};
  color: black;
  width: 19px;
  height: 19px;
  text-align: center;
  margin-left: auto;
  font-size: 11px;
  line-height: 17px;
  font-family: ${fonts.bold};
  margin-top: auto;
`

export const StHeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: ${IS_BLACK_FRIDAY ? `1px solid white` : `1px solid #3331314d`};
  padding-bottom: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: ${fontSizes.headlineMobile};
  font-family: ${props => (props.isActive ? fonts.bold : fonts.regular)};
`

export const StOptionContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.isMobile ? '1fr 1fr' : '1fr')};
  flex-direction: column;
  transition: max-height 0.3s ease-in-out;
  max-height: ${props => (props.isOpen ? `${props.optionsCount * 24.5}px` : '0px')};
  overflow-y: hidden;
  padding-bottom: ${props => (props.isOpen ? '16px' : '0')};
  border-bottom: ${props =>
    props.isOpen
      ? IS_BLACK_FRIDAY
        ? '1px solid white'
        : '1px solid #3331314d'
      : IS_BLACK_FRIDAY
        ? '1px solid black'
        : '1px solid white'};

  @supports (-moz-appearance: none) {
    max-height: ${props => (props.isOpen ? `${props.optionsCount * 26}px` : '0px')};
  }
`

export const FilterValue = styled.span`
  cursor: pointer;
  font-family: ${props => (props.isActive ? fonts.bold : fonts.regular)};
  font-size: ${fontSizes.filterContainerMobile};
  padding-left: 1.9rem;
`

export const Container = styled.div`
  margin-bottom: ${props => (props.isOpen ? '10px' : '0')};
  font-family: ${fonts.regular};
  padding: 0 12px;
  min-width: 180px;
`

export const StColor = styled.div`
  width: 13px;
  height: 13px;
  background-color: ${props => props.color};
  padding: 1px;
  border: ${props =>
    props.isActive
      ? '1px solid white'
      : props.color === '#FFFFFF'
        ? '1px solid #3331314d'
        : '1px solid transparent'};
  position: absolute;
  outline: ${props => (props.isActive ? '1px solid black' : '1px solid transparent')};
  transform: translate(8%, 15%);
  margin-right: 0.5rem;
`

export const StMultiColor = styled.img`
  width: 16px;
  height: 16px;
  background-color: ${props => props.color};
  border: ${props =>
    props.isActive
      ? '1px solid white'
      : props.color === '#FFFFFF'
        ? '1px solid #3331314d'
        : '1px solid transparent'};
  position: absolute;
  outline: ${props => (props.isActive ? '1px solid black' : '1px solid transparent')};
  transform: translate(4%, 15%);
  margin-right: 0.5rem;
`
